<template>
  <div class="ma-4">
   <v-snackbar v-model="msg" top> {{ text }} <v-btn color="pink" text  @click="msg = false"> Close</v-btn></v-snackbar>
   <v-row dense>
    <v-col cols="12" sm="12">
      <v-card class="pa-2" outlined tile height="100%">
        <v-tabs v-model="tab">
          <v-tabs-slider color="yellow"></v-tabs-slider>
          <v-tab v-for="item in items" :key="item">
            {{ item }}
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
          <v-tab-item v-for="(item, i) in items" :key="item">
            <v-card class="pa-2" outlined tile height="100%">
              <v-data-table
                :headers="headers"
                :items="i === 0 ? repairs : completedRepairs"
                sort-by="Date"
                sort-desc
                :loading="isLoading"
                loading-text="Loading Repairs"
                :search="reportFilters.search"
                height="550"
              >
                <template v-slot:top>
                  <v-toolbar flat color="white">
                    <v-toolbar-title>Maintenance Request</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                    <v-text-field
                      v-model="reportFilters.search"
                      clearable
                      flat
                      solo-inverted
                      hide-details
                      prepend-inner-icon="search"
                      label="search"
                      class="desktop"
                    ></v-text-field>
                    <v-spacer></v-spacer>
                    <v-btn color="#2b3990" dark class="mb-2" @click="showAdd()"
                    >
                    <v-icon left>add</v-icon>
                    Add Request</v-btn
                  >
                    
                  </v-toolbar>
                  <v-text-field
                    v-model="search"
                    clearable
                    flat
                    solo-inverted
                    hide-details
                    prepend-inner-icon="search"
                    label="search"
                    class="mobile ml-5 mr-5 mb-3 mt-3"
                  ></v-text-field>
                </template>

               
                
              

              <template v-slot:item.actions="{ item }">
                  <!-- <v-icon small class="mr-2" @click="viewMaintenance(item)">
                    mdi-eye
                  </v-icon> -->

                  <v-btn x-small class="ma-1" @click="viewMaintenance(item)">View</v-btn>

                  <v-btn x-small class="ma-1 error" @click="deleteRepair(item)">Delete</v-btn>


                  <!-- <v-icon small @click="deleteMaintenance(item)">
                    mdi-delete
                  </v-icon> -->

                </template>
                <template v-slot:no-data>
                  <v-btn color="#2b3990" class="white--text" @click="getMaintenance()">Reset</v-btn>
                </template>
              </v-data-table>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
      <v-dialog v-model="dialog" max-width="100%">
        
        <v-card>
          <v-card-title style="background-color: #2b3990">
            <span class="headline white--text">{{ titleForm  }}</span>
          </v-card-title>
          <v-card-text>
            <v-form
              ref="form"
              lazy-validation>
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="4">
                  <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="true"
                    :return-value.sync="date"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="newDate"
                        label="Today's Date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        clearable
                        :rules="requiredField"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="newDate"
                      no-title
                      scrollable
                    >
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="12" md="4">
                  <v-menu
                    ref="menu2"
                    v-model="menu2"
                    :close-on-content-click="true"
                    :return-value.sync="date"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="newIncidentDate"
                        label="Incident Date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        clearable
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="newIncidentDate"
                      no-title
                      scrollable
                    >
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="12" md="4">
                  <v-menu
                    ref="menu3"
                    v-model="menu3"
                    :close-on-content-click="true"
                    :return-value.sync="date"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="newRequestDate"
                        label="Date Request Submitted"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        clearable
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="newRequestDate"
                      no-title
                      scrollable
                    >
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="12" md="4">
                  <v-text-field
                    label="Manager's Name"
                    v-model="newManager"
                  ></v-text-field>
                </v-col>
                <v-col cols="6" sm="6" md="4" v-if="!editMaintenance">
                  <v-select
                    :items="programs"
                    item-value="_id"
                    item-text="Name"
                    label="Program"
                    v-model="newProgram"
                    :rules="requiredField"
                  ></v-select>
                </v-col>
                <v-col cols="6" sm="6" md="4" v-if="editMaintenance">
                  <v-text-field
                    label="Program"
                    v-model="newProgram"
                    readonly
                    :rules="requiredField"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="4">
                  <v-menu
                    ref="menu4"
                    v-model="menu4"
                    :close-on-content-click="true"
                    :return-value.sync="date"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="newDateSubmitted"
                        label="Date IR was Submitted"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        clearable
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="newDateSubmitted"
                      no-title
                      scrollable
                    >
                    </v-date-picker>
                  </v-menu>
                </v-col>

                <v-col cols="12">
                  Incident Report
                </v-col>
                <v-col cols="12" sm="12">
                  <v-textarea
                    v-model="newDamagedArea"
                    label="Area of the house damaged"
                    outlined
                  ></v-textarea>
                </v-col>

                <v-col cols="12" sm="12">
                  <span>Incident Involved (Select all that apply)</span>
                  <v-row>
                    <v-col cols="12" md="2">
                      <v-switch
                        v-model="newIncidentInvolved"
                        label="Client Involved"
                        value="Client Involved"
                        hide-details
                      ></v-switch>
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-switch
                        v-model="newIncidentInvolved"
                        label="Staff Involved"
                        value="Staff Involved"
                        hide-details
                      ></v-switch>
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-switch
                        v-model="newIncidentInvolved"
                        label="Outside Events"
                        value="Outside Events"
                        hide-details
                      ></v-switch>
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-switch
                        v-model="newIncidentInvolved"
                        label="Other"
                        value="Other"
                        hide-details
                      ></v-switch>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    v-if="newIncidentInvolved == 'Other'"
                    label="Please Explain"
                    v-model="newOther"
                    outlined
                  ></v-textarea>
                </v-col>

                <v-col cols="12">
                    <v-textarea
                        label="Repairs Needed"
                        outlined
                        v-model="newRepairs"
                    ></v-textarea>
                </v-col>
                <v-col cols="12">
                    <v-checkbox
                        label="Manager's Signature"
                        v-model="managerSigned"
                        @click="managerSignature()"
                    ></v-checkbox>
                    <v-text-field
                      v-model="newManagerSignature"
                    ></v-text-field>
                </v-col>
                <v-col cols="12">
                    <v-checkbox
                        label="Supervisor's Signature"
                        v-model="supervisorSigned"
                        @click="supervisorSignature()"
                    ></v-checkbox>

                    <v-text-field
                      v-model="newSupervisorSignature"
                    ></v-text-field>
                </v-col>

                <h1>Upload Pictures of the Damage</h1>

                <v-col class="d-flex" cols="12" sm="12">
                  <v-file-input
                    v-model="newImage"
                    class="pa-2"
                    label="New Image"
                    show-size
                    filled
                    multiple
                    prepend-icon="mdi-camera"
                    accept="image/*"
                    @change="imgSelected"
                  >
                    <template #selection="{ text, index }">
                      <v-chip small label close color="primary" @click:close="deleteChip(index)">{{ text }}</v-chip>
                    </template>
                  </v-file-input>
                </v-col>
                <v-carousel>
                  <template v-for="(image, _id) in imageDetails">
                    <v-carousel-item
                      :key="_id"
                    >
                      <v-row class="flex-nowrap" style="height:100%">
                        <v-img :src="image.AWSLink">
                          <v-row class="fill-height"
                                align="center"
                                justify="center"
                          >
                            <div style="color: #000;padding-top: 30%;">{{ image.Name }}

                              <v-chip
                              close color="primary" @click="deleteImage(image._id)">Delete</v-chip>
                            </div>
                          </v-row>

                        </v-img>

                      </v-row>
                    </v-carousel-item>
                  </template>
                  <!--
                  <v-carousel-item
                    v-for="(item,i) in imageDetails"
                    :key="i"
                  >
                    <v-img :src="item.AWSLink"></v-img>
                  </v-carousel-item>
                  -->
                </v-carousel>
                <v-col class="d-flex" cols="12" sm="12">
                  <template >
                    <v-img
                      :src="newImageLink"
                      height="200px;"
                    ></v-img>
                  </template>
                </v-col>


                <h1>Administrative Use Only</h1>

                <v-col cols="12">
                  <v-select
                    label="Status of Request"
                    :items="conditions"
                    v-model="newCondition"
                  ></v-select>
                </v-col>

                <v-col cols="12">
                <v-menu
                    ref="menu5"
                    v-model="menu5"
                    :close-on-content-click="true"
                    :return-value.sync="date"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="newNotificationDate"
                        label="Maintenance Notification Date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        clearable
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="newNotificationDate"
                      no-title
                      scrollable
                    >
                    </v-date-picker>
                  </v-menu>
                </v-col>

                <v-col cols="12">
                    <v-text-field
                        label="Name of Company Assigned"
                        v-model="newCompany"
                    ></v-text-field>
                </v-col>

                <v-col cols="12">
                    <v-text-field
                        label="Name of Person Repairing House"
                        v-model="newName"
                        outlined
                    ></v-text-field>
                </v-col>

                <v-col cols="12">
                    <v-text-field
                        label="Phone"
                        v-model="newPhone"
                        outlined
                    ></v-text-field>
                </v-col>

                <v-col cols="12">
                    <v-text-field
                        label="Email"
                        v-model="newEmail"
                        outlined
                    ></v-text-field>
                </v-col>

                <v-col cols="12">
                    <v-textarea
                        label="Notes"
                        v-model="newNotes"
                        outlined
                    ></v-textarea>
                </v-col>

                <v-col cols="12">
                <v-menu
                    ref="menu6"
                    v-model="menu6"
                    :close-on-content-click="true"
                    :return-value.sync="date"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="newExpectedDate"
                        label="Expected Completion Date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        clearable
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="newExpectedDate"
                      no-title
                      scrollable
                    >
                    </v-date-picker>
                  </v-menu>
                </v-col>

                <v-col cols="12">
                <v-menu
                    ref="menu7"
                    v-model="menu7"
                    :close-on-content-click="true"
                    :return-value.sync="date"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="newActualDate"
                        label="Actual Completion Date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        clearable
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="newActualDate"
                      no-title
                      scrollable
                    >
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12">

                  <v-switch
                  label="Complete"
                  :input-value="newStatus"
                  v-model="newStatus"
                  ></v-switch>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              fab
              small
              class="white--text"
              color="#2b6993"
              elevation="4"
              @click="printReport"
            >
            <v-icon>print</v-icon>
            </v-btn>
            <v-btn class="white--text" color="#259647" @click="addMaintenance()" v-if="newMaintenance">Save</v-btn
            >
            <v-btn color="blue darken-1" class="white--text" @click="updateMaintenance()" v-if="editMaintenance">Update</v-btn
            >
            <v-btn color="darken-1" @click="close" text>Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
    </v-row>
    <Foot/>
  </div>
</template>

<script>
import axios from 'axios'
import Foot from '../components/Footer'
// import moment from 'moment'
import Swal from "sweetalert2";
import ReportFilters from '@/mixins/reportFilters.js';

const url = require("../client_config/config").url;

export default {
    mixins: [
        ReportFilters,
    ],
  components: {
      Foot,
  },
  data: function() {
    return {
      headers: [
        {
          text: 'Date Added',
          align: 'start',
          sortable: false,
          value: 'Date',
        },
        { text: "Scheduled Repair Date", value: "ExpectedDate" },
        { text: "Completed Date", value: "ActualDate" },
        { text: "Program", value: "Program.Name" },
        { text: "Repair Needed", value: "Repairs" },
        { text: "Repair Company", value: "Company" },
        { text: "Status", value: "Condition" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      items: ["Incomplete", "Completed"],
      tab: null,
      date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      menu: false,
      menu1: false,
      menu2: false,
      menu3: false,
      menu4: false,
      menu5: false,
      menu6: false,
      menu7: false,
      dialog: false,
      editMaintenance: false,
      newMaintenance: false,
      msg: false,
      search: "",
      text:"",
      repairs: [],
      completedRepairs: [],
      tempData: [],
      users: [],
      staff: "",
      userID: localStorage.getItem("userID"),
      titleForm: "New Maintenance Request",
      maintenanceID: "",
      newDate: "",
      newIncidentDate: "",
      newRequestDate: "",
      newManager: "",
      newProgram: "",
      newDateSubmitted: "",
      newIncidentReport: "",
      newDamagedArea: "",
      newIncidentInvolved: [],
      newRepairs: "",
      newManagerSignature: "",
      newSupervisorSignature: "",
      newDocuments: [],
      newReason: "",
      newNotificationDate: "",
      newCompany: "",
      newName: "",
      newPhone: "",
      newEmail: "",
      newNotes: "",
      newExpectedDate: "",
      newActualDate: "",
      newInvoiceSubmitted: false,
      newAdminSignature: "",
      newImage: [],
      imageDetails: [],
      newImageLink: "",
      isLoading: true,
      uploadImg: "",
      userState: localStorage.getItem('userState'),
      programs: [],
      staffName: localStorage.getItem("Name"),
      managerSigned: false,
      supervisorSigned: false,
      newStatus: "",
      newCondition: "",
      conditions: [
        "Vendor Contacted",
        "In Process",
        "On Hold",
        "Waiting for Parts"
      ],
      requiredField: [
        v => !!v || 'This field is required'
      ],
      reportFilters:  {
          search: '',
      },
      reportFilterName: 'ReportFilters_HouseMaintenance',
    };
  },

  computed: {
    formTitle() {
      return this.editedIndex != 1 ? "New Item" : "Edit Item";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    reportFilters: {
        handler(newVal) {
          this.setReportFilters(this.reportFilterName, newVal);
        },
        deep: true
    }
  },

  created() {
    this.getMaintenance();
    this.getPrograms();
    this.reportFilters = this.getReportFilters(this.reportFilterName) ?? this.reportFilters;
  },

  methods: {
    initialize() {
      this.repairs = [];
    },
    validate() {
      return this.$refs.form.validate()
    },
    validateReset() {
        if (this.$refs.form !== undefined) {
            this.$refs.form.reset();
        }
    },
    async getPrograms () {
        const companyIds = localStorage.getItem('userCompanies');

        await axios.get(`${url}/units/state/${this.userState}`,{
            params: {
                Company: JSON.parse(companyIds)
            }
        })
        .then((res) => {
            this.programs = res.data.units;
        });
      },
    viewMaintenance(item) {
      this.titleForm= "Viewing Maintenance Request";
      this.dialog = true;
      this.editMaintenance = true;
      this.newMaintenance = false;
      this.newDate = item.Date;
      this.newIncidentDate = item.IncidentDate;
      this.newRequestDate = item.RequestDate;
      this.newManager = item.Manager;
      this.newProgram = item.Program.Name;
      this.newDateSubmitted = item.DateSubmitted;
      this.newIncidentReport = item.IncidentReport;
      this.newDamagedArea = item.DamagedArea;
      this.newIncidentInvolved = item.IncidentInvolved;
      this.newOther = item.Other;
      this.newRepairs = item.Repairs;
      this.newManagerSignature = item.ManagerSignature;
      this.newSupervisorSignature = item.SupervisorSignature;
      this.newReason = item.Reason;
      this.newNotificationDate = item.NotificationDate;
      this.newCompany = item.Company;
      this.newName = item.Name;
      this.newPhone = item.Phone;
      this.newEmail = item.Email;
      this.newNotes = item.Notes;
      this.newExpectedDate = item.ExpectedDate;
      this.newActualDate = item.ActualDate;
      this.newInvoiceSubmitted = item.InvoiceSubmitted;
      this.newAdminSignature = item.AdminSignature;
      this.newStatus = item.Status === 'Complete' ? true: false;
      this.newCondition = item.Condition;
      this.maintenanceID = item._id;
      this.imageDetails = item.Documents;

    },
    showAdd() {
      this.titleForm= "New House Maintenance";
      this.dialog = true
      this.newMaintenance = true;
      this.editMaintenance = false;
    },

    deleteRepair(item) {
      const id = item._id;
      confirm("Are you sure you want to delete this repair?") &&
      this.repairDelete(id);
    },

    repairDelete(id) {
      axios.delete(`${url}/houseMaintenance/${id}`)
      .then((response) => {
        this.getMaintenance();
        if (response.status == 400) {
          response.json().then(function(data) {
            return data.msg;
          });
        }
        this.msg=true;
        this.text="The request has been deleted successfully.";
      });
    },

    clear(){
      this.newDate = "";
      this.newIncidentDate = "";
      this.newIncidentDate = "";
      this.newRequestDate = "";
      this.newManager = "";
      this.newProgram = "";
      this.newDateSubmitted = "";
      this.newIncidentReport = "";
      this.newDamagedArea = "";
      this.newIncidentInvolved = [];
      this.newOther = "";
      this.newRepairs = "";
      this.newManagerSignature = "";
      this.newSupervisorSignature = "";
      this.newDocument = "";
      this.newReason = "";
      this.newNotificationDate = "";
      this.newCompany = "";
      this.newName = "";
      this.newPhone = "";
      this.newEmail = "";
      this.newNotes = "";
      this.newExpectedDate = "";
      this.newActualDate = "";
      this.newInvoiceSubmitted = false;
      this.newAdminSignature = "";
      this.newStatus = "";
      this.newCondition = "";
      this.newImage = [];
      this.imageDetails = [];
      this.validateReset()
    },

    close() {
      this.dialog = false;
      this.clear();
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    async updateMaintenance() {
      const data = {
        Date: this.newDate,
        IncidentDate: this.newIncidentDate,
        RequestDate: this.newRequestDate,
        Manager: this.newManager,
        DateSubmitted: this.newDateSubmitted,
        DamagedArea: this.newDamagedArea,
        IncidentReport: this.newIncidentReport,
        IncidentInvolved: this.newIncidentInvolved,
        Other: this.newOther,
        Repairs: this.newRepairs,
        ManagerSignature: this.newManagerSignature,
        SupervisorSignature: this.newSupervisorSignature,
        Reason: this.newReason,
        Document: this.newDocument,
        NotificationDate: this.newNotificationDate,
        RepairCompany: this.newCompany,
        Name: this.newName,
        Phone: this.newPhone,
        Email: this.newEmail,
        Notes: this.newNotes,
        ExpectedDate: this.newExpectedDate,
        ActualDate: this.newActualDate,
        InvoiceSubmitted: this.newInvoiceSubmitted,
        AdminSignature: this.newAdminSignature,
        Status: this.newStatus ? "Complete" : "Incomplete",
        Condition: this.newCondition,
        UrlNotification: this.$router.history.current.path,
      };

      try {
        const response = await axios.put(
          `${url}/houseMaintenance/${this.maintenanceID}`,
          data
        );

        if (response.status === 400) {
          const data = await response.json();
          alert(data.msg);
          return;
        }

        this.msg = true;
        this.text = "The house maintenance has been updated successfully.";
        await this.saveImg();
        this.getMaintenance();
        this.close();
      } catch (error) {
        console.error("Error updating maintenance:", error);
      }
    },

    getMaintenance: function() {
      this.isLoading = true;
      let endpoint = `${url}/houseMaintenance/report`;

      axios.get(endpoint)
        .then(res => {
          this.repairs = res.data.incomplete;
          this.completedRepairs = res.data.completed;
        }).finally(() => this.isLoading = false);
    },

    async addMaintenance() {
      try {
        if (!this.validate()) {
          this.msg = true;
          this.text = "Please fill all required fields";
          return;
        }
        const data = {
          Date: this.newDate,
          IncidentDate: this.newIncidentDate,
          RequestDate: this.newRequestDate,
          Manager: this.newManager,
          Program: this.newProgram,
          DateSubmitted: this.newDateSubmitted,
          DamagedArea: this.newDamagedArea,
          IncidentReport: this.newIncidentReport,
          IncidentInvolved: this.newIncidentInvolved,
          Other: this.newOther,
          Repairs: this.newRepairs,
          ManagerSignature: this.newManagerSignature,
          SupervisorSignature: this.newSupervisorSignature,
          Reason: this.newReason,
          Document: this.newDocument,
          NotificationDate: this.newNotificationDate,
          RepairCompany: this.newCompany,
          Name: this.newName,
          Phone: this.newPhone,
          Email: this.newEmail,
          Notes: this.newNotes,
          ExpectedDate: this.newExpectedDate,
          ActualDate: this.newActualDate,
          InvoiceSubmitted: this.newInvoiceSubmitted,
          AdminSignature: this.newAdminSignature,
          Status: this.newStatus ? "Complete" : "Incomplete",
          Condition: this.newCondition,
          UrlNotification: this.$router.history.current.path,
        };

        const response = await axios.post(`${url}/houseMaintenance/add`, data);

        if (response.status === 400) {
          const data = await response.json();
          this.text = data.msg;
          return;
        }

        this.msg = true;
        this.text = "The new house maintenance has been added successfully.";
        this.maintenanceID = response.data._id;
        await this.saveImg();
        this.getMaintenance();
        this.close();
      } catch (error) {
        console.error("Error adding maintenance:", error);
      }
    },

    getUsers() {
        axios.get(`${url}/users`).then(async res => {
            this.users = res.data.users;
            for (let i=0; i < this.users.length; i++){
              if (this.userID === this.users[i]._id) {
                this.staff = this.users[i].Name
              }
            }
            this.newEnteredBy = this.staff + " - " + new Date();
        });
      },

    imgSelected(e) {
      this.uploadImg=e;
    },

    saveImg() {
      this.message = "";
      for (let i = 0; i < this.uploadImg.length; i++) {
        this.uploadFiles(this.uploadImg[i]);
      }
    },

    uploadFiles(file) {
      const formData = new FormData();
      formData.append('damage-img', file);
      var ct = { headers:{"content-type" : "multipart/form-data"}};
      axios.post(`${url}/houseMaintenance/fileuploader/${this.maintenanceID}`,formData, ct)
      .then(res => {
        if(res){
          this.getMaintenance();
        }
      })
      .catch(err => {
        console.log(err);
      });
    },

    deleteChip(index) {
      this.newImage.splice(index, 1);
    },

    managerSignature() {
      if (this.managerSigned) {
        this.newManagerSignature = this.staffName + " - " + new Date();
      } else {
        this.newManagerSignature = "";
      }
    },

    supervisorSignature() {
      if (this.supervisorSigned) {
        this.newSupervisorSignature = this.staffName + " - " + new Date();
      } else {
        this.newSupervisorSignature = "";
      }
    },

    deleteImage(imageId) {
      axios.delete(`${url}/houseMaintenance/${this.maintenanceID}/deleteImage/${imageId}`)
      .then(res => {
        if(res){
          this.imageDetails = res.data.data;
        }
      })
      .catch(err => {
        console.log(err);
      });
    },

    async printReport(){
      Swal.fire({
        title: "Print in Progress",
        text: "Please wait while the PDF is being generated and processed. This may take a while if some images or files are attached.",
        allowOutsideClick: false,
        allowEscapeKey: false,
        showCancelButton: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      fetch(`${url}/houseMaintenance/download-report/${this.maintenanceID}`)
        .then((response) => response.blob())
        .then((blob) => {
          const blobUrl = URL.createObjectURL(blob);
          const printWindow = window.open(blobUrl);

          printWindow.onload = function () {
            Swal.close();
            printWindow.print();
            URL.revokeObjectURL(blobUrl);
          };
        })
        .catch((error) => {
          console.error("Error generating or printing the PDF:", error);
          Swal.fire("Error", "Failed to generate or print the PDF", "error");
        });

    }

  },

};
</script>
<style>
@media only screen and (min-width: 768px) {
    .mobile {
      display: none;
    }
  }

  @media only screen and (max-width: 600px) {
    .desktop {
      display: none;
    }

  }
</style>
